// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5tj+b","label":"styles_label__o7UTn","require":"styles_require__jzlXY"};